
/////////////////////////////////
// aviation insurance

function initAviationForm() {

	if ($("#aviationForm").length > 0) {

		$form = $("#aviationForm");

		//init progress view
		$form.find(".progressViewElement").removeClass("disabled");
		$form.find(".progressViewElement").removeClass("active");
		$form.find(".progressViewElement").eq(0).addClass("active");
		//$form.find(".progressViewElement").eq(1).addClass("active");
		$form.find(".progressViewElement").eq(2).addClass("disabled");

		//init form blocks
		$form.find(".avif-progressBlock").hide();
		$formBlock1 = $form.find("#avif-progressBlock1").show().addClass("active");
		$formBlock2 = $form.find("#avif-progressBlock2");
		$formBlock3 = $form.find("#avif-progressBlock3");

		//handle summary change buttons
		$form.find(".summaryChangeButton").click(function (e) {
			e.preventDefault();
			var id = parseInt($(this).attr("data-id")) - 1;
			aviationFormStep($form.find(".progressViewElement").eq(id), false);
		});
		$form.find(".summaryChangeButton").on("keydown", handleKeyDownForClick);

		initAviationFormPageButtons();

		//submit button
		$("#avif_submitButton").click(function () {
			$("#aviationForm").submit();
		});
		$("#avif_submitButton").on("keydown", handleKeyDownForClick);
	}
}

function initAviationFormPageButtons() {
	//handle button next/prev
	$form.find(".buttonPrev").unbind().click(function () {
		//console.log("prev");
		aviationFormStep($form.find(".progressViewElement.active").prev(), false);
	});
	$form.find(".buttonNext").unbind().click(function () {
		//console.log("next");
		aviationFormStep($form.find(".progressViewElement.active").next(), true);
	});
	$form.find(".buttonPrev").on("keydown", handleKeyDownForClick);
	$form.find(".buttonNext").on("keydown", handleKeyDownForClick);
}

function createAviationFormSummaryRowClone($firstSummaryRow, newId) {

	var $summaryClone = $firstSummaryRow.clone();
	$summaryClone.find(".formSummaryText").each(function () {
		$(this).attr("id", $(this).attr("id") + newId);
	});

	$summaryClone.find('label .uploadFileElement').html($(this).data('infotext'));

	return $summaryClone;

}

function aviationFormStep($progressViewElement, validate) {

	var validationResult = true;
	if (validate) {
		//validate form
		validationResult = validateAviationForm();
	}
	else {
		//disable validation => set result to true
		validationResult = true;
	}

	if (validationResult) {
		//console.log("validated!");
		var blockId = $progressViewElement.attr("data-block-id");
		$("#aviationForm").find(".progressViewElement").removeClass("active");
		$progressViewElement.prevAll(".progressViewElement").removeClass("done");
		$progressViewElement.prevAll(".progressViewElement").addClass("done");
		$progressViewElement.addClass("active");
		$progressViewElement.next().removeClass("disabled");
		$("#aviationForm").find(".avif-progressBlock").hide().removeClass("active");
		$("#aviationForm").find("#" + blockId).show().addClass("active");

		$('html, body').animate({
			scrollTop: $progressViewElement.offset().top - 60
		}, 100);

		initAviationFormPageButtons();
		updateAviationFormSummary();
	}
	else {
		//console.log("not validated!");
		scrollToError();
		// validation error!
	}
}

function validateAviationForm() {

	var $currentBlock = $("#aviationForm").find(".avif-progressBlock.active");

	var error = false;

	$currentBlock.find("input").each(function () {
		if (getAviationFormFieldError($(this))) {
			error = true;
		}
	});
	$currentBlock.find("textarea").each(function () {
		if (getAviationFormFieldError($(this))) {
			error = true;
		}
	});
	$currentBlock.find("select").each(function () {
		if (getAviationFormFieldError($(this))) {
			error = true;
		}
	});

	if (error) {
		return false;
	}

	return true;
}

function getAviationFormFieldError($ff) {

	var required = $ff.hasClass("requiredData");
	var visible = $ff.is(":visible");

	if ($ff.parent(".select-style").length > 0) {
		visible = $ff.parent(".select-style").is(":visible");
	}
	if ($ff.parent(".fileUpload").length > 0) {
		visible = $ff.parent(".fileUpload").is(":visible");
	}

	//console.log("validate... " + $ff.attr("id") + " (visible:" + visible + " / required:" + required + ")");

	var error = false;

	if (visible && required) {

		$ff.closest(".form-field").removeClass("error");
		$ff.siblings(".form-field__errormessage--1").hide();
		$ff.siblings(".form-field__errormessage--2").hide();

		//use hidden field on file upload fields
		if ($ff.siblings(".uploadCVFileElement").length > 0) {
			$ff = $ff.siblings(".uploadCVFileElement");
		}

		//check value
		if (!$ff.val() || $ff.val() == "") {
			$ff.closest(".form-field").addClass("error");
			$ff.siblings(".form-field__errormessage--1").show();
			error = true;
		}

		//check mail
		if ($ff.attr("id") == "inputEmail" && $ff.val() != "") {
			if (!validateEmail($ff.val())) {
				$ff.closest(".form-field").addClass("error");
				$ff.siblings(".form-field__errormessage--2").show();
				error = true;
			}
		}

		//console.log("validate ok! " + $ff.attr("id"));
	}
	return error;
}

function updateAviationFormSummary() {

	var $form = $("#aviationForm");

	//add value to summary
	$form.find(".summaryData").each(function () {
		var id = $(this).attr("data-summary-id");
		var field = $form.find("#" + id);
		var value = "";

		if ($(this).is("input")) {
			value = $(this).val();
		}
		else if ($(this).is("select")) {
			value = $(this).val();
		}
		else if ($(this).is("textarea")) {
			value = $(this).val();
		}

		if (value == "") {
			value = "-"
		}

		field.html(value);
	});


	//insurances
	var listInsurances = "";
	$form.find(".checkboxInsurance").each(function () {
		if ($(this).prop("checked")) {
			listInsurances += $(this).attr("data-value") + ", ";
		}
	});

	if (listInsurances.length > 0) {
		listInsurances = listInsurances.substr(0, listInsurances.length - 2);
	}

	$("#avif-summary-listInsurances").html(listInsurances);

}
